/**
 *	This code was gladly borrowed from
 *  https://github.com/getsentry/sentry-javascript/blob/d136f4e0bca43cda21db42da4e84bbe3448a70a1/packages/utils/src/object.ts
 */ export const fill = (source, name, replacementFactory)=>{
    if (!(name in source)) {
        return;
    }
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') {
        try {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __apm_original__: {
                    enumerable: false,
                    value: original
                }
            });
        } catch (_e) {
        // This can throw if multiple fill happens on a global object like XMLHttpRequest
        // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
        }
    }
    source[name] = wrapped;
};
